import { mutator } from 'satcheljs';
import { appsPreloaded } from '../actions/internalActions';
import { getStore } from '../store/store';

mutator(appsPreloaded, ({ appsPreloaded }) => {
    const store = getStore();

    // Mark the apps as preloaded so we don't do it again in the session
    appsPreloaded.forEach(app => (store.appsPreloaded[app] = true));
});
